<template>
    <div></div>
</template>

<script>
  export default {
    name: 'ExtensionArea'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/extension/ExtensionArea.vue